const requiredField = (v: any) => !!v || 'Field is required.';

const isFilled = (v: any): boolean => {
  if (v === 0) return true;
  if (v === '' || v === null || v === undefined) return false;
  return !!v;
};

export default class WorkItemRules {
  readonly required = [requiredField];

  readonly requiredNumber = [
    (v: any) => {
      if (v === 0) return true;
      return requiredField(v);
    },
  ];

  readonly workItemType = [
    (v: any) => !!v.id || 'Field is required.',
  ];

  readonly parent = [
    (v: any) => {
      const message = 'Field is required.';
      if (v === null) return message;
      return !!v.id || message;
    },
  ];

  readonly title = [
    requiredField,
    (v: any) => (!!v && v.length <= 255) || 'Title length must be smaller than 255 characters.',
    (v: any) => (!!v && v.length > 3) || 'Title length must be greater than 3 characters.',
  ]

  readonly assignedTo = [
    (v: any[]) => v.length > 0 || 'Field is required',
  ];

  requiredEstimateOrStoryPoints = (active: boolean, counterpart: any, message: string) => [
    (v: any) => !active || isFilled(v) || isFilled(counterpart) || message,
  ];
}
